var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('app-header'),_c('app-jumbotron'),_c('app-summary'),_c('app-numbers'),_c('app-workflow'),_c('app-clouds'),_c('app-benefits'),_c('app-plugins'),_c('app-startup-quote'),_c('app-call-to-action'),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }